import React from "react";
import { Link, useLocation } from "react-router-dom";
import IntlMessages from "Util/IntlMessages";
import { getSuiteNav, type SuiteNavItem } from "./suiteNav";

/**
 * On suite overview (index) routes, surface the first few sub-tabs as deep links.
 * @param {{ vertical: string }} props
 */
export default function OverviewQuickLinks({ vertical }: { vertical: string }) {
  const location = useLocation();
  const base = `/app/main/layout/${vertical}`.replace(/\/+/g, "/");
  const path = (location.pathname || "").replace(/\/+$/, "") || base;
  const isOverview = path === base;

  const items = (getSuiteNav(vertical) || []).filter(
    (i: SuiteNavItem) => i.to && i.to !== "."
  );
  const preview = items.slice(0, 3);
  if (!isOverview || !preview.length) return null;

  return (
    <div className="mb-4 p-3 bg-light rounded border">
      <div className="small text-muted mb-2">
        <IntlMessages id="suite.overview.quick-links" />
      </div>
      <div className="d-flex flex-wrap gap-2">
        {preview.map((item: SuiteNavItem) => (
          <Link
            key={item.to}
            to={item.to}
            className="btn btn-sm btn-outline-primary"
          >
            <IntlMessages id={item.labelId} />
          </Link>
        ))}
      </div>
    </div>
  );
}
